import { render, staticRenderFns } from "./InputsOrdered.vue?vue&type=template&id=44f70c3b&scoped=true&"
import script from "./InputsOrdered.vue?vue&type=script&lang=js&"
export * from "./InputsOrdered.vue?vue&type=script&lang=js&"
import style0 from "./InputsOrdered.vue?vue&type=style&index=0&id=44f70c3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f70c3b",
  null
  
)

/* custom blocks */
import block0 from "./InputsOrdered.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VCol,VContainer,VRadio,VRadioGroup,VRow,VSelect})
